import React, { useContext, useState } from 'react';
import OrderClientData from './OrderClientData';
import ProductClientData from './ProductClientData';
import { faSearch, faCopy } from '@fortawesome/free-solid-svg-icons'
import { getOrderData } from '../../../../hooks/api/odoo';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import './instapagostStyle.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { generateTempUrl, getPayLink } from '../../../../hooks/api/instapago';
import PopUp from '../../../general/popUps/PopUp';

function InstapagoMobilePayment() {
  const [preNumOrder, setPreNumOrder] = useState('')
  const [numOrder, setNumOrder] = useState('')
  const [orderData, setOrderData] = useState([])
  const [loading, setLoading] = useState(false)
  const [linkPay, setLinkPay] = useState('')
  const [orderId, setOrderId] = useState('')
  const [linkActive, setLinkActive] = useState(false)
  const [tasaBancaria, setTasaBancaria] = useState(0)
  const globalContext = useContext(GlobalContext);
  const [showPopUp, setShowPopUp] = useState(false)
  const [popUpData, setPopUpData] = useState({message: "", action: "", status: "" });
  const [payTerms, setPayTerms] = useState([]);
  const search = async () =>{
    setLoading(true);
    setLinkActive(false)
    const entId = await globalContext.currentEnterpriseId;
    if(!preNumOrder){
      setLoading(false)
      return
    }
    try {
      const getData = await getOrderData(entId, preNumOrder);
      if (!getData) {
          setShowPopUp(true)
          setPopUpData({
            message: 'No fue posible obtener la información de la orden.',
            action: 'No se pudo recuperar los datos',
            status: 'error'
          })
          setLoading(false);
          return;
      }
      
      setNumOrder(preNumOrder);
      setOrderData(getData);
      setTasaBancaria(getData.tazaCambio)
      const payTermsFn= await getData.billDetails.map((item)=>item.invoice_payment_term_id);
      setPayTerms(payTermsFn)
      const orderidParser = preNumOrder.replaceAll("/", "-")
      const payLink = await getPayLink(orderidParser);
      const url = `${window.location.origin}/${payLink.payLink}`;
      setOrderId(orderidParser)
      setLinkPay(url)
      if(payLink.payLink) setLinkActive(true)

    } catch (error) {
      console.error('Error al obtener datos:', error);
    } finally {
      setLoading(false);
    }
  }

  const createPayLink = async () =>{
    const entId = await globalContext.currentEnterpriseId;
    const getStatus = await generateTempUrl(entId, orderData)
    const orderidParser = preNumOrder.replaceAll("/", "-")
    const payLink = await getPayLink(orderidParser);
    const url = `${window.location.origin}/${payLink.payLink}`;
    
    setLinkPay(url)
    setLinkActive(true)
    setShowPopUp(true)
    setPopUpData({
      message: getStatus?.message,
      action: 'Link de pago creado correctamente', 
      status: 'success'
    })

  }

  const copyLink = async () =>{
      await navigator.clipboard.writeText(linkPay);
      alert('Link de pago copiado!')
  }

  return (
    <div className=''>
      {
        showPopUp && (
          <PopUp setShow={setShowPopUp} message={popUpData.message} action={popUpData.action} status={popUpData.status} />
        )
      }
        <div className="py-2 px-3" style={{backgroundColor: '#014788'}}>
            <h1
              className="text-white display-5 text-center m-0"
              style={{ fontSize: '2rem', padding: '.5rem 0' }}
            >
              Creación de link de pago
            </h1>
        </div>
        {
          tasaBancaria > 0 && (
            <div className='mt-3' style={{ 
              background: '#014788',
              padding: '0.6rem',
              maxWidth: '500px',
              margin: 'auto',
              borderRadius: '1rem 0'
            }}>
                <h5 style={{fontSize:'1rem', textAlign:'center', color: 'white', textShadow: '0px 0px 2px black'}} className='m-0'>
                  Tasa bancaria del dia: 
                  <span style={{fontSize:'1rem', fontWeight:'bold', marginLeft: '.45rem'}}>
                    {tasaBancaria}
                  </span>
                </h5>
            </div>
          )
        }
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className='d-flex flex-column flex-md-row justify-content-center' style={{gap:15, maxWidth:850, margin:'auto', marginTop:50}}>
                <div className={`input-group container-search justify-content-center ${Object.keys(orderData).length > 0 && !loading && 'active'}`}>
                  <span className="input-group-text" id="basic-addon3">Numero de factura</span>
                  <input type="text" className="form-control" id='input-num-order-instapago' style={{maxWidth:300}} value={preNumOrder} onChange={((v)=>setPreNumOrder(v.target.value))} placeholder='VBS/2025/09/1234'/>
                  <div className={`d-flex align-items-center justify-content-center px-4 text-white search`} style={{cursor:'Pointer', backgroundColor: '#014788'}} onClick={()=>search()}>
                    <FontAwesomeIcon icon={faSearch}/>
                  </div>

                </div>
                {
                  Object.keys(orderData).length > 0 && !loading &&(
                    <div className='d-flex justify-content-end' style={{gap:15}}>
                      <button className="btn btn-danger" onClick={()=>createPayLink()} disabled={linkActive}>Crear link de pago</button>
                    </div>
                  )
                }
              </div>
            </div>
            {Object.keys(orderData).length > 0 && !loading && (
              <>
                  {
                    linkActive === true && (
                      <div className='col-12 d-flex justify-content-center align-items-center mt-4'>
                      <span className="input-group-text">Link de pago</span>
                      <input type="text" className="form-control w-100" id='link-pay' disabled style={{maxWidth:330}} value={`Link creado con éxito para ${orderId}`}/>
                      <FontAwesomeIcon icon={faCopy} color='#014788' id='icon-copy' onClick={()=>copyLink()}/>
                  </div>
                    )
                  }
                  <div className="col-12 mt-5">
                  <div>
                    <OrderClientData numOrder={numOrder} customerInfo={orderData.customerInfo}/>
                    <div className="col-12 px-0">
                      <ProductClientData productData={orderData.billLines} saleOrderData={orderData.billDetails} tasaBancaria={tasaBancaria} initialPaymentTerm={orderData.initialPaymentTerm}/>
                    </div>
                    <h4 
                      className='text-center mt-4 mb-2' 
                      style={{
                        background: '#014788',
                        color: '#FFFFFF',
                        padding: '.9rem',
                        maxWidth: '450px',
                        borderRadius: '1rem',
                        margin: 'auto'
                      }}
                    >
                      Terminos de pago: {payTerms.map((item) => item[1])}
                    </h4>
                  </div>
                </div>
                
              </>
            ) 
          
          }
          {
            loading && (
              <div className='col-12 d-flex justify-content-center align-items-center' style={{height: 'calc(100vh - 400px)'}}>
                <div className="loader"></div>
              </div>
            )
          }
          </div>
        </div>
    </div>
  )
}
export default InstapagoMobilePayment   
